"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[25214],{

/***/ 25214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8920);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63457);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22318);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41107);
/* harmony import */ var _Link_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31520);
/* harmony import */ var _material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(58365);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86010);
/* harmony import */ var _datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86700);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94455);









function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        root: {
            padding: theme.spacing(6, 0)
        },
        isWhite: {
            color: theme.palette.common.white
        },
        isBlack: {
            color: theme.palette.common.black
        },
        section: (_obj = {
            position: 'relative',
            overflow: 'hidden',
            padding: theme.spacing(4, 0),
            margin: 'auto',
            '& .MuiContainer-root': {
                position: 'relative',
                zIndex: 2
            }
        }, _defineProperty(_obj, theme.breakpoints.up('lg'), {
            padding: theme.spacing(8, 0),
            display: 'flex',
            minHeight: '90vh',
            maxHeight: 1200,
            flexDirection: 'column',
            justifyContent: 'center'
        }), _defineProperty(_obj, '& .content', {
            '& >*:not([data-oembed-type=video])': {
                display: 'block',
                maxWidth: theme.breakpoints.width('xl'),
                padding: theme.spacing(0, 3),
                margin: theme.spacing(3, 'auto')
            }
        }), _obj),
        sectionFull: _defineProperty({
            padding: 0,
            '& .MuiContainer-root': {
                padding: 0,
                maxWidth: '100%'
            },
            '& .content': {
                '& >*:not([data-oembed-type=video])': {
                    display: 'block',
                    maxWidth: theme.breakpoints.width('xl'),
                    padding: theme.spacing(0, 3),
                    margin: theme.spacing(3, 'auto')
                }
            }
        }, theme.breakpoints.up('lg'), {
            minHeight: '56.25vh'
        }),
        image: {
            position: 'absolute',
            top: 0,
            left: 0,
            objectFit: 'cover',
            objectPosition: 'top',
            zIndex: 0,
            height: '100%',
            width: '100%'
        },
        imageOverlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1,
            height: '100%',
            width: '100%'
        },
        content: {
            '& *': {
                marginTop: 0
            },
            '& a': {
                display: 'inline-block'
            },
            '&.left': {
                textAlign: 'left'
            },
            '&.center': {
                textAlign: 'center',
                '& ol, & ul': {
                    textAlign: 'left'
                }
            },
            '&.right': {
                textAlign: 'right',
                '& ol, & ul': {
                    direction: 'rtl'
                }
            }
        },
        skeletonCta: {
            borderRadius: theme.spacing(3),
            height: 45,
            display: 'inline-block'
        },
        center: {
            textAlign: 'center',
            marginBottom: theme.spacing(1)
        }
    });
});
var HerosSection = function(param) {
    var homePage = param.homePage, t = param.t;
    var ref, ref1, ref2;
    var classes = useStyles();
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var trackEvent = (0,_datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)().trackEvent;
    var isMobile = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(theme.breakpoints.down('sm'));
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "section-heros section__spacer ".concat(classes.root),
        id: "hero-sections",
        children: (homePage === null || homePage === void 0 ? void 0 : (ref = homePage.data) === null || ref === void 0 ? void 0 : ref.hero_sections.length) > 0 && (homePage === null || homePage === void 0 ? void 0 : (ref1 = homePage.data) === null || ref1 === void 0 ? void 0 : ref1.hero_sections[0].hero_content.length) > 0 ? homePage === null || homePage === void 0 ? void 0 : (ref2 = homePage.data) === null || ref2 === void 0 ? void 0 : ref2.hero_sections.map(function(el, index) {
            var hero_content = el.hero_content, hero_background = el.hero_background, hero_cta_link = el.hero_cta_link, hero_cta_label = el.hero_cta_label, align_content = el.align_content, hero_title = el.hero_title, width = el.width;
            var alignContent;
            switch(align_content){
                case 'left':
                    alignContent = 'left';
                    break;
                case 'center':
                    alignContent = 'center';
                    break;
                case 'right':
                    alignContent = 'right';
                    break;
            }
            return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    width: !isMobile ? width : '100%'
                },
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(classes.section, classes.sectionFull),
                id: "section-hero--".concat(index + 1),
                children: [
                    hero_background.url !== undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(theme.breakpoints.down('sm')) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('section-hero__image', classes.image),
                                src: hero_background.small.url,
                                alt: ''
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('section-hero__image', classes.image),
                                src: hero_background.url,
                                alt: ''
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)('section-hero__overlay', classes.imageOverlay)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        maxWidth: "md",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "content ".concat(classes.content, " ").concat(alignContent, " ").concat(hero_background.url !== undefined ? classes.isWhite : classes.isBlack),
                            children: [
                                (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .isPrismicText */ .LT)(hero_title) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    variant: "h2",
                                    className: classes.center,
                                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(hero_title)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                    data: hero_content
                                }),
                                hero_cta_link.url !== undefined && (hero_cta_label.length !== 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    href: hero_cta_link.url,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        target: hero_cta_link.target === '_blank' ? '_blank' : '_self',
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            variant: 'contained',
                                            color: 'primary',
                                            className: "section-heros__cta",
                                            component: "span",
                                            onClick: function() {
                                                return trackEvent({
                                                    category: 'HomePage',
                                                    href: hero_cta_link.url,
                                                    action: "CTA click ".concat((0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(hero_cta_label)),
                                                    name: "from Hero section to ".concat(hero_cta_link.url)
                                                });
                                            },
                                            children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(hero_cta_label)
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_lab_Skeleton__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                    variant: "rect",
                                    className: classes.skeletonCta,
                                    width: 200,
                                    height: 45
                                }))
                            ]
                        })
                    })
                ]
            }, index));
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classes.section,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: classes.image,
                                src: '/images/placeholder.jpg',
                                alt: ''
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classes.imageOverlay
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        maxWidth: "md",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "".concat(classes.content, " ", 'right', " ").concat(classes.isWhite),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: t('texts:general:add_a_text')
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    href: '/shop',
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        target: '_blank',
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            variant: 'contained',
                                            color: 'primary',
                                            className: "section-heros__cta",
                                            component: "span",
                                            children: t('texts:general:add_a_text')
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (HerosSection);


/***/ })

}]);